import { buttonBlueprint } from "@made-people/blueprint-button/blueprint";

export const button = buttonBlueprint.override({
  slots: {
    wrapper:
      "border-[var(--border)] bg-[var(--default-bg)] hover:bg-[var(--hover-bg)] data-[is-selected=true]:bg-[var(--active-bg)] active:bg-[var(--active-bg)] data-[appear-disabled=true]:bg-[var(--disabled-bg)] aria-disabled:bg-[var(--disabled-bg)] data-[appear-disabled=true]:border-less-emphasis-2 flex justify-center items-center appearance-none relative overflow-hidden transition-none aria-disabled:pointer-events-none cursor-pointer aria-disabled:cursor-default group/button",
    labelWrapper: "flex items-center gap-2 shrink-0 h-full",
    label:
      "text-[var(--default-label)] fill-[var(--default-label)] group-aria-disabled/button:text-[var(--disabled-label)] group-hover/button:text-[var(--hover-label)] group-data-[is-selected=true]/button:text-[var(--active-label)] group-data-[appear-disabled=true]/button:text-[var(--disabled-label)] group-active/button:text-[var(--active-label)] flex text-center items-center justify-center w-full h-full whitespace-nowrap select-none transition-none",
    iconLeft:
      "text-[var(--default-label)] group-aria-disabled/button:text-[var(--disabled-label)] fill-[var(--default-label)] group-aria-disabled/button:fill-[var(--disabled-label)] shrink-0 flex justify-center items-center h-4 w-4",
    iconRight:
      "text-[var(--default-label)] group-aria-disabled/button:text-[var(--disabled-label)] fill-[var(--default-label)] group-aria-disabled/button:fill-[var(--disabled-label)] shrink-0 flex justify-center items-center h-4 w-4",
    progressIcon:
      "[&>svg]:stroke-[var(--default-label)] [&>svg]:group-hover/button:stroke-[var(--hover-label)] [&>svg]:group-active/button:stroke-[var(--active-label)] flex absolute text-center items-center justify-center w-full h-full top-0 left-0 [&>svg]:w-5 [&>svg]:h-5",
  },
  variants: {
    justifyContent: {
      start: { labelWrapper: "justify-start" },
      center: { labelWrapper: "justify-center" },
      end: { labelWrapper: "justify-end" },
      between: {
        labelWrapper: "justify-between w-full",
        label: "w-full flex justify-between",
      },
    },
    alignLabel: {
      left: {
        wrapper: "justify-start",
      },
      center: {
        label: "justify-center",
      },
      right: {
        label: "justify-end",
      },
    },
    color: {
      primary: {
        wrapper:
          "[--default-bg:theme(colors.button-primary-default.bg)] [--default-label:theme(colors.button-primary-default.label)] [--hover-bg:theme(colors.button-primary-hover.bg)] [--hover-label:theme(colors.button-primary-hover.label)] [--active-bg:theme(colors.button-primary-active.bg)] [--active-label:theme(colors.button-primary-active.label)] [--disabled-bg:theme(colors.button-primary-disabled.bg)] [--disabled-label:theme(colors.button-primary-disabled.label)]",
      },
      secondary: {
        wrapper:
          "[--default-bg:theme(colors.button-secondary-default.bg)] [--default-label:theme(colors.button-secondary-default.label)] [--hover-bg:theme(colors.button-secondary-hover.bg)] [--hover-label:theme(colors.button-secondary-hover.label)] [--active-bg:theme(colors.button-secondary-active.bg)] [--active-label:theme(colors.button-secondary-active.label)] [--disabled-bg:theme(colors.button-secondary-disabled.bg)] [--disabled-label:theme(colors.button-secondary-disabled.label)",
      },
      white: {
        wrapper:
          "[--default-bg:theme(colors.button-white-default.bg)] [--default-label:theme(colors.button-white-default.label)] [--hover-bg:theme(colors.button-white-hover.bg)] [--hover-label:theme(colors.button-white-hover.label)] [--active-bg:theme(colors.button-white-active.bg)] [--active-label:theme(colors.button-white-active.label)] [--disabled-bg:theme(colors.button-white-disabled.bg)] [--disabled-label:theme(colors.button-white-disabled.label)",
      },
      black: {
        wrapper:
          "[--default-bg:theme(colors.button-black-default.bg)] [--default-label:theme(colors.button-black-default.label)] [--hover-bg:theme(colors.button-black-hover.bg)] [--hover-label:theme(colors.button-black-hover.label)] [--active-bg:theme(colors.button-black-active.bg)] [--active-label:theme(colors.button-black-active.label)] [--disabled-bg:theme(colors.button-black-disabled.bg)] [--disabled-label:theme(colors.button-black-disabled.label)]",
        label: "group-data-[is-selected=true]/button:!text-white",
      },
      grey: {
        wrapper:
          "bg-[#e2dfd7] hover:bg-[#e4e2da] hover:text-black hover:fill-black active:bg-[#e4e2da] [--default-label:theme(colors.button-white-default.label)] [--hover-label:theme(colors.button-white-hover.label)]",
      },
    },
    style: {
      solid: {
        wrapper: "",
      },
      outline: {
        wrapper: "bg-transparent border-[1.5px]",
      },
      transparent: {
        wrapper:
          "!bg-transparent disabled:!bg-transparent data-[appear-disabled=true]:!bg-transparent",
      },
    },
    size: {
      sm: {
        wrapper: "h-9",
        labelWrapper: "px-3",
        progressIcon: "[&>svg]:scale-[0.8]",
        label: "text-button-sm",
        iconLeft: "w-3 h-3",
        iconRight: "w-3 h-3",
      },
      md: {
        wrapper: "h-12",
        labelWrapper: "px-5",
        label: "text-button-md",
        iconLeft: "w-5 h-5",
        iconRight: "w-5 h-5",
      },
      lg: {
        wrapper: "h-12",
        labelWrapper: "px-5",
        label: "text-button-md",
        iconLeft: "w-5 h-5",
        iconRight: "w-5 h-5",
      },
    },
    rounded: {
      full: {
        wrapper: "rounded-full",
      },
      lg: {
        wrapper: "rounded-lg",
      },
      md: {
        wrapper: "rounded-md",
      },
      sm: {
        wrapper: "rounded-sm",
      },
      none: {
        wrapper: "rounded-none",
      },
    },
    width: {
      auto: {
        wrapper: "w-fit min-w-fit",
      },
      full: {
        wrapper: "w-full",
      },
      fixed: {
        wrapper: "w-full",
      },
      "same-as-height": {
        wrapper: "aspect-square min-w-fit",
      },
    },
  },
  compoundVariants: [
    {
      variants: {
        color: "primary",
        style: "outline",
      },
      slots: {
        wrapper:
          "[--border:theme(colors.button-primary-default.bg)] [--default-bg:transparent] [--default-label:theme(colors.button-primary-default.bg)] [--hover-bg:transparent] [--hover-label:theme(colors.button-primary-default.bg)] [--active-bg:transparent] [--active-label:theme(colors.button-primary-default.bg)] [--disabled-bg:transparent] [--disabled-label:theme(colors.button-primary-default.bg)]",
      },
    },
    {
      variants: {
        color: "secondary",
        style: "outline",
      },
      slots: {
        wrapper:
          "[--border:theme(colors.button-secondary-default.bg)] [--default-bg:transparent] [--default-label:theme(colors.button-secondary-default.bg)] [--hover-bg:transparent] [--hover-label:theme(colors.button-secondary-default.bg)] [--active-bg:transparent] [--active-label:theme(colors.button-secondary-default.bg)] [--disabled-bg:transparent] [--disabled-label:theme(colors.button-secondary-default.bg)]",
      },
    },
    {
      variants: {
        color: "black",
        style: "outline",
      },
      slots: {
        wrapper:
          "[--border:theme(colors.button-black-default.bg)] [--default-bg:transparent] [--default-label:theme(colors.button-black-default.bg)] [--hover-bg:transparent] [--hover-label:theme(colors.button-black-default.bg)] [--active-bg:black] [--active-label:theme(colors.button-black-default.bg)] [--disabled-bg:transparent] [--disabled-label:theme(colors.button-black-default.bg)]",
      },
    },
    {
      variants: {
        color: "white",
        style: "outline",
      },
      slots: {
        wrapper:
          "[--border:theme(colors.button-white-default.bg)] [--default-bg:transparent] [--default-label:theme(colors.button-white-default.bg)] [--hover-bg:transparent] [--hover-label:theme(colors.button-white-default.bg)] [--active-bg:transparent] [--active-label:theme(colors.button-white-default.bg)] [--disabled-bg:transparent] [--disabled-label:theme(colors.button-white-default.bg)]",
      },
    },
    {
      variants: {
        size: "sm",
        width: "fixed",
      },
      slots: {
        wrapper: "max-w-[140px]",
      },
    },
    {
      variants: {
        size: "md",
        width: "fixed",
      },
      slots: {
        wrapper: "max-w-[200px]",
      },
    },
  ],
  defaultVariants: {
    style: "solid",
    color: "primary",
    size: "md",
    width: "auto",
    rounded: "md",
    justifyContent: "center",
  },
});
